import { render, staticRenderFns } from "./FormArticles.vue?vue&type=template&id=441fae86&scoped=true"
import script from "./FormArticles.vue?vue&type=script&lang=js"
export * from "./FormArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441fae86",
  null
  
)

export default component.exports